import compileGeneralAdmission from './compilers/compileGeneralAdmission';

export default ({ GeneralAdmission }, { payload }) => {
    for (const hash of Object.keys(payload)) {
        const generalAdmission = GeneralAdmission.get({ hash });
        if (generalAdmission) {
            generalAdmission.seatsUsed = payload[hash];
            compileGeneralAdmission(generalAdmission);
        }
    }
};
